/**
 * This file was automatically generated.
 *
 * PLEASE DO NOT EDIT MANUALLY!
 *
 * Refer to scripts/tokens/README.md for information.
 *
 */
export default {
  /**
   * Pass-through tokens.
   */
  white: "var(--pnr-white)",

  /**
   * Brand tokens.
   */
  brandPrimary: "var(--pnr-neutral80)",
  brandSecondary: "var(--pnr-yellow30)",

  /**
   * Typography tokens.
   */
  textPrimary: "var(--pnr-neutral100)",
  textSecondary: "var(--pnr-neutral70)",
  textTertiary: "var(--pnr-neutral60)",
  textDisabled: "var(--pnr-neutral40)",
  textInverse: "var(--pnr-white)",
  linkPrimary: "var(--pnr-indigo70)",
  linkPrimaryInverse: "var(--pnr-neutral05)",
  linkPrimaryInverseHover: "var(--pnr-indigo40)",
  text01: 27,
  text02: 22,
  text03: 20,
  text04: 17,
  text05: 16,
  text06: 15,
  text07: 13,

  /**
   * Focus tokens.
   */
  focusLight: "var(--pnr-lime10)",
  focusDark: "var(--pnr-lime60)",

  /**
   * Surfaces tokens.
   */
  surfacePrimary: "var(--pnr-neutral10)",
  surfaceSecondary: "var(--pnr-white)",
  surfaceTertiary: "var(--pnr-neutral05)",
  surfacePrimaryHover: "var(--pnr-neutral20)",
  surfaceSecondaryHover: "var(--pnr-neutral05)",
  surfaceTertiaryHover: "var(--pnr-neutral10)",
  surfacePrimaryActive: "var(--pnr-neutral30)",
  surfaceSecondaryActive: "var(--pnr-neutral10)",
  surfaceTertiaryActive: "var(--pnr-white)",
  surfaceDark: "var(--pnr-neutral80)",
  surfaceSelected: "var(--pnr-indigo70)",
  surfaceSelectedLight: "var(--pnr-indigo10)",
  surfaceSelectedHover: "var(--pnr-indigo80)",

  /**
   * Action tokens.
   */
  actionPrimary: "var(--pnr-yellow30)",
  actionSecondary: "var(--pnr-white)",
  actionTertiary: "var(--pnr-neutral05)",
  actionPrimaryHover: "var(--pnr-neutral80)",
  actionSecondaryHover: "var(--pnr-neutral80)",
  actionTertiaryHover: "var(--pnr-neutral10)",
  actionPrimaryPressed: "var(--pnr-neutral100)",
  actionSecondaryPressed: "var(--pnr-neutral100)",
  actionTertiaryPressed: "var(--pnr-neutral20)",
  actionPrimaryDisabled: "var(--pnr-neutral20)",
  actionSecondaryDisabled: "var(--pnr-neutral20)",
  actionTertiaryDisabled: "var(--pnr-white)",

  /**
   * Borders tokens.
   */
  borderDisabled: "var(--pnr-neutral20)",
  borderMinimal: "var(--pnr-neutral30)",
  borderSubtle: "var(--pnr-neutral40)",
  borderModerate: "var(--pnr-neutral60)",
  borderStrong: "var(--pnr-neutral80)",
  borderActive: "var(--pnr-indigo70)",

  /**
   * Messaging tokens.
   */
  messagingError: "var(--pnr-coral60)",
  messagingErrorLight: "var(--pnr-coral10)",
  messagingSuccess: "var(--pnr-green60)",
  messagingSuccessLight: "var(--pnr-green10)",
  messagingWarning: "var(--pnr-orange50)",
  messagingWarningLight: "var(--pnr-orange10)",
  messagingInformation: "var(--pnr-purple60)",
  messagingInformationLight: "var(--pnr-purple10)",
  messagingUtility: "var(--pnr-neutral80)",
  messagingUtilityLight: "var(--pnr-neutral10)",

  /**
   * Iconography tokens.
   */
  iconUtility: "var(--pnr-neutral100)",
  iconInverse: "var(--pnr-white)",
  iconDisabled: "var(--pnr-neutral40)",
  iconAlert: "var(--pnr-coral60)",
  iconConfirmation: "var(--pnr-green60)",
  iconImpairment: "var(--pnr-orange60)",
  iconInformation: "var(--pnr-purple60)",

  /**
   * Print tokens.
   */
  printColor: "var(--pnr-pure-black)",

  /**
   * Progress tokens.
   */
  progressPrimary: "var(--pnr-coral70)",
  progressSecondary: "var(--pnr-neutral60)",

  /**
   * ToggleSwitch tokens.
   */
  toggleSwitchOff: "var(--pnr-neutral60)",
  toggleSwitchDisabled: "var(--pnr-neutral40)",
  toggleSwitchDisabledSurface: "var(--pnr-neutral05)",
  togglePrimary: "var(--pnr-indigo60)"
};